module.exports = __webpack_public_path__ + "img/shengcheng.b1ea4270.png";